import { z } from 'zod';

export const OkResult = z.object({ ok: z.literal(true) });

export interface PaginatedParams {
  cassa?: string;
  page?: number;
  limit?: number;
  sort?: string;
  sortDir?: 'asc' | 'desc';
  q?: string;
  da?: string;
  a?: string;
  statoLavoratore?: string;
  note?: string;
}

export function buildQueryUrl(base: string, opts: PaginatedParams = {}): string {
  const params = new URLSearchParams();
  if (opts.cassa) params.set('cassa', opts.cassa);
  if (opts.page) params.set('page', String(opts.page));
  if (opts.limit) params.set('limit', String(opts.limit));
  if (opts.sort) params.set('sort', opts.sort);
  if (opts.sortDir) params.set('sortDir', opts.sortDir);
  if (opts.q) params.set('q', opts.q);
  if (opts.da) params.set('da', opts.da);
  if (opts.a) params.set('a', opts.a);
  if (opts.statoLavoratore) params.set('statoLavoratore', opts.statoLavoratore);
  if (opts.note) params.set('note', opts.note);
  const qs = params.toString();
  return `${base}${qs ? (base.includes('?') ? '&' : '?') + qs : ''}`;
}
